import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import {
  FaUserAlt,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaShieldAlt,
  FaSignInAlt,
} from "react-icons/fa";
import { login } from "../../services/auth";
import API_BASE_URL from "../../config/api";
import "./Login.css";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/admin/login`,
        {
          username: data.username,
          password: data.password,
        }
      );

      login(response.data.token);
      navigate("/help-support");
    } catch (err) {
      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-bg">
      <div className="login-overlay"></div>

      <Row className="justify-content-center w-100 position-relative">
        <Col md={6} lg={4}>
          <Card className="login-card">
            {/* HEADER */}
            <div className="login-header">
              <div className="login-icon">
                <FaShieldAlt />
              </div>
              <h4>Owner Builder</h4>
              <p>Admin Secure Login</p>
            </div>

            <Card.Body className="p-4">
              {error && (
                <Alert variant="danger" className="py-2 small text-center">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit(onSubmit)}>
                {/* USERNAME */}
                <div className="input-group-modern mb-3">
                  <span className="input-icon">
                    <FaUserAlt />
                  </span>
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    {...register("username", { required: true })}
                  />
                </div>

                {/* PASSWORD */}
                <div className="input-group-modern mb-4">
                  <span className="input-icon">
                    <FaLock />
                  </span>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    {...register("password", { required: true })}
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                {/* BUTTON */}
                <Button
                  type="submit"
                  disabled={loading}
                  className="login-btn w-100"
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" animation="border" className="me-2" />
                      Logging in...
                    </>
                  ) : (
                    <>
                      <FaSignInAlt className="me-2" />
                      Login Securely
                    </>
                  )}
                </Button>

                <div className="text-center mt-4 small">
                  © {new Date().getFullYear()} Owner Builder
                </div>
              </Form>
            </Card.Body>
          </Card>

          <div className="login-footer text-center mt-3">
            Need help? Contact system administrator
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
